import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { API_URL } from '@equine-ui-nx/injection-tokens';
import { IShowEntryDetailsResponse } from "../interfaces/showEntryDetailsResponse.interface";


@Injectable({providedIn: 'root'})
export class EntryPaymentsService {
  
  private http = inject(HttpClient);
  private apiUrl = inject(API_URL);
  // private apiUrl = 'http://localhost:8080/api';

  isShowRegistered(showId: string): Observable<{found: boolean, link?: any}> {
    const GET_LINK = `showEntryPayments/getLinkCreatedByShowId`;

    return this.http.post<{found: boolean, link?: any}>(`${this.apiUrl}/${GET_LINK}`, { showId });
  }

  getOnboardingLink(showId: string, redirectUrl: string): Observable<{href: string}> {
    const GET_ONBOARDING_URL = `showEntryPayments/getPaypalReferalUrl`;

    return this.http.post<{href: string}>(`${this.apiUrl}/${GET_ONBOARDING_URL}`, { showId, redirectUrl });
  }

  captureEntries(orderId: string, showEntriesPaymentIds: string[]): Observable<any> {
    const CAPTURE_SHOW_ENTRIES = `showEntryPayments/captureShowEntries`;

    return this.http.post<any>(`${this.apiUrl}/${CAPTURE_SHOW_ENTRIES}`, { orderId, showEntriesPaymentIds });
  }

  payShowEntries(orderIds: string[], showId: string): Observable<{shows: IShowEntryDetailsResponse[], greatTotal: number, products: any[]}> {
    const CREATE_PAYMENT_DETAILS_WITH_ORDERS = `showEntryPayments/addEntriesToPaymentDetails`;

    return this.http.post<{shows: IShowEntryDetailsResponse[], greatTotal: number, products: any[]}>(`${this.apiUrl}/${CREATE_PAYMENT_DETAILS_WITH_ORDERS}`, { orderIds, showId });
  }

  getPaypalOrderId(showPaymentDetailsIds: string[], fromCard = false): Observable<{paypalOrder: {id: string}, id: string}> {
    const GET_PAYPAL_ORDER_ID_BY_SHOW_ENTRY_DETAILS = 'showEntryPayments/getPaypalOrderByShowDetailsId';
    return this.http.post<{paypalOrder: {id: string}, id: string}>(`${this.apiUrl}/${GET_PAYPAL_ORDER_ID_BY_SHOW_ENTRY_DETAILS}`, { showPaymentDetailsIds, fromCard });
  }

  updateLinkWithMerchantId(showId: string) {
    const UPDATE_LINK = 'showEntryPayments/updateLinkWithMerchantId';
    return this.http.post<any>(`${this.apiUrl}/${UPDATE_LINK}`, { showId });
  }

  getPaypalOrderForShowFee(showFeeDetailsIds: string[], fromCard = false) {
    const GET_PP_ORDER_ID = 'showEntryPayments/getPaypalOrderIdForShowEntryFee';
    return this.http.post<any>(`${this.apiUrl}/${GET_PP_ORDER_ID}`, { showFeeDetailsIds, fromCard });
  }

  captureShowFees(orderId: string, showFeeDetailsIds: string[]): Observable<any> {
    const CAPTURE_SHOW_ENTRIES = `showEntryPayments/captureShowEntryFee`;

    return this.http.post<any>(`${this.apiUrl}/${CAPTURE_SHOW_ENTRIES}`, { orderId, showFeeDetailsIds });
  }


}